<template>
    <div>
        <game-detail :details='details'></game-detail>
    </div>
</template>

<script>
import gameDetail from '../../components/gamedetail/gamedetail'

import logo_img from '../../images/xianlaigame/xl_nm.png'
import ercodeimg from '../../images/gamecenter_ercode/ercode_nm.png'
import list_img1 from '../../images/download/down-neimeng1.jpg'
import list_img2 from '../../images/download/down-neimeng2.jpg'
import list_img3 from '../../images/download/down-neimeng3.jpg'
import cut_img1 from '../../images/download/nmjt1.png'
import cut_img2 from '../../images/download/nmjt2.png'
import cut_img3 from '../../images/download/nmjt3.png'
export default {
    data(){
        return{
            details:{
                logo_img:logo_img,
                name:'龙腾内蒙麻将',
                size:'134.3',
                load_count:'196',
                desp:'龙腾内蒙麻将是一款休闲棋牌游戏，画面精美音乐动听，真人对战实时约局，拥有最原汁原味的内蒙本地规则，让您无论身在何处都可以和朋友们玩到最纯正的内蒙麻将！',
                ios_url:'http://app1.xlsymj.com/?downloadfrom=neimeng',
                android_url:'http://app1.xlsymj.com/?downloadfrom=neimeng',
                ercodeimg:ercodeimg,
                list_img1:list_img1,
                list_img2:list_img2,
                list_img3:list_img3,
                cut_img1:cut_img1,
                cut_img2:cut_img2,
                cut_img3:cut_img3
            }
        }
    },
    components:{
        gameDetail
    }
}
</script>

<style scoped>

</style>
